export const INVITATION_RESOURCE = 'invitation';
export const COMPLETE_INVITATION_RESOURCE = 'completeInvitation';
export const COMMUNITY_LEGAL_DOCUMENTS_RESOURCE = 'communityLegalDocuments';
export const LEGAL_DOCUMENTS_RESOURCE = 'legalDocuments';
